
    import './styles.scoped.css';
    export default {
  "vertical-connector": "awsui_vertical-connector_1r2pu_1ojm3_5",
  "grid": "awsui_grid_1r2pu_1ojm3_9",
  "absolute": "awsui_absolute_1r2pu_1ojm3_19"
};
  